/* @flow weak */
// ES5+ polyfills
// These consist of all the polyfills required by Babel.
import 'babel-polyfill';

// Left here in case we need this again. For now we handle any asynchronous polyfills
// before our app starts at all, using https://polyfill.io/
// Asynchronous polyfills
export default Promise.resolve();



// WEBPACK FOOTER //
// ./src/polyfill.js